import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Building07 = function Building07(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M7.5 11H4.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C3 11.7599 3 12.0399 3 12.6V21m13.5-10h2.9c.5601 0 .8401 0 1.054.109a1 1 0 0 1 .437.437c.109.2139.109.4939.109 1.054V21m-4.5 0V6.2c0-1.1201 0-1.6802-.218-2.108a2 2 0 0 0-.874-.874C14.9802 3 14.4201 3 13.3 3h-2.6c-1.1201 0-1.6802 0-2.108.218a2 2 0 0 0-.874.874C7.5 4.5198 7.5 5.08 7.5 6.2V21M22 21H2m9-14h2m-2 4h2m-2 4h2"
    })
  }));
};
export default Building07;